/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { Modal, ModalBody, Row, Col, Button, Input } from 'reactstrap';
import useApi from '../../hooks/useApi';
import { AlertMessage } from '../AlertMessage/AlertMessage';
import { useTranslation } from 'react-i18next';

const DischargeCase = ({
  title = 'Alert',
  titleDarkSide = '',
  subText = 'Are you sure you wish to cancel your changes?',
  noBtnHandler,
  yesBtnHandler,
  yesBtnText = 'Yes',
  noBtnText = 'No',
  btnsStyle = {},
  caseId,
  ...restProps
}) => {
  const { t } = useTranslation('common');
  const { Api, consumed } = useApi();
  const [selectedItem, setSelectedItem] = useState({ key: -1, value: '' });
  const [options, setOptions] = useState([]);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const [showAlertMessage, setShowAlertMessage] = useState({
    visibility: false,
    msg: ''
  });

  useEffect(() => {
    if (restProps.isOpen) {
      setSelectedItem({ key: -1, value: '' });

      Api.meta
        .getUsersCaseMeta(caseId || undefined)
        .then((res) => {
          const { data } = res;
          const { meta } = data;
          const cancel_reason = meta[0]['case_cancel_reasons'];
          setOptions(cancel_reason);
        })
        .catch((e) => {
          if (e.response && e.response.status) {
            let status = e.response.status;
            displayAlertMessage(`Fetch reasons error-${status}`);
            consumed(e);
          }
        });
    }

    return () => {
      setConfirmLoading(false);
    };
  }, [restProps.isOpen]);

  const onReasonChanged = (e) => {
    let key = e.target.value;

    if (key == -1) {
      //don't change it to === comparison
      setSelectedItem({ key: -1, value: '' });
      return;
    }

    var values = options.filter(function (item) {
      return item.case_cancel_code == e.target.value;
    });
    let value = values[0].case_cancel_desc;

    setSelectedItem({ key: key, value: value });
  };

  const displayAlertMessage = (msg = '') => {
    setShowAlertMessage({ visibility: true, msg });
    let t = setTimeout(() => {
      setShowAlertMessage({ visibility: false, msg });
      clearTimeout(t);
    }, 7000);
  };

  return (
    <Modal size="lg" {...restProps} centered data-testid="discharge-case-modal">
      <ModalBody>
        <Row>
          <Col className="vl-flex-col-center">
            <AlertMessage message={showAlertMessage.msg} visibility={showAlertMessage.visibility} />
            <div style={styles.title}>
              {title}
              {titleDarkSide.trim().length > 0 ? <span style={styles.titleDarkSide}>{` ${titleDarkSide}`}</span> : null}
            </div>
            {subText !== '' && <div style={styles.subText}>{subText}</div>}
            <div className="vl-select">
              <Input
                className="minimal"
                type="select"
                style={styles.select}
                value={selectedItem.key}
                onChange={onReasonChanged}
                placeholder={t('Select from dropdown')}
                data-testid="discharge-case-reason"
              >
                <option value={-1}>{t('Select from dropdown')}</option>
                {options.map(function (data, i) {
                  return (
                    <option key={i} value={data.case_cancel_code}>
                      {data.case_cancel_desc}
                    </option>
                  );
                })}
              </Input>
            </div>
            <div className="vl-flex-row-center" style={styles.btnsContainer}>
              {noBtnText !== '' && (
                <Button style={{ ...styles.btnGray, ...btnsStyle }} type="button" onClick={noBtnHandler}>
                  {noBtnText}
                </Button>
              )}
              {yesBtnText !== '' && (
                <Button
                  style={{ ...styles.mainBtn, ...btnsStyle }}
                  type="button"
                  disabled={selectedItem.key === -1 || confirmLoading}
                  onClick={() => {
                    setConfirmLoading(true);
                    yesBtnHandler(selectedItem);
                  }}
                >
                  {yesBtnText}
                </Button>
              )}
            </div>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export { DischargeCase };

const styles = {
  btnsContainer: { marginBottom: '30px' },
  mainBtn: {
    width: '110px',
    height: '40px',
    backgroundColor: 'var(--productPrimary)',
    fontSize: '14px',
    padding: '4px 10px',
    borderColor: 'var(--productPrimary)',
    color: 'var(--productPrimaryDark)'
  },
  btnGray: {
    width: '110px',
    height: '40px',
    backgroundColor: 'var(--productGray)',
    fontSize: '14px',
    padding: '4px 10px',
    borderColor: 'var(--productGray)',
    marginRight: '10px'
  },
  title: { color: 'var(--productPink)', fontSize: '30px', fontWeight: 'bold' },
  titleDarkSide: { color: 'var(--productGray)', fontWeight: 'bold' },
  subText: {
    color: 'var(--productGray)',
    fontSize: '14px',
    marginTop: '30px',
    marginBottom: '30px'
  },
  select: {
    width: '400px',
    marginBottom: '30px'
  }
};
